import { render, staticRenderFns } from "./TeacherRootView.vue?vue&type=template&id=e483de82"
import script from "./TeacherRootView.vue?vue&type=script&lang=js"
export * from "./TeacherRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports